import { render } from "./ProvinceIcon.vue?vue&type=template&id=5df039c0"
const script = {}

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__